import React from 'react';
import PageHero from '../components/layout/PageHero';
import ChargingSimulator from '../components/tools/ChargingSimulator';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';

const ChargingSimulatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="charging-simulator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Charging Simulator"
        description="Model realistic CC-CV EV charging behavior — voltage, current, and power over a full charging session — instead of a naive energy ÷ power estimate."
        testId="charging-simulator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
          <Alert data-testid="charging-assumptions-note">
            <Info className="h-4 w-4" />
            <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Assumptions</AlertTitle>
            <AlertDescription>
              This tool solves a physics-based CC-CV curve each step from a chemistry-typical
              OCV/taper model, a single reference pack's measured DCIR map (scaled to your pack's
              voltage and capacity), chemistry-typical BMS temperature/SoC current limits,
              charger and onboard-charger losses, and a two-node pack/coolant thermal model with
              cooling/heating — it is an{' '}
              <strong>engineering approximation</strong> for understanding charging behavior,
              not a replay of any manufacturer's measured charging curve. Real-world charging
              time and power vary by vehicle, pack age/health, ambient conditions, and charger
              hardware — see the User Guide's Assumptions &amp; Limitations section for full
              sourcing details and known limitations.
            </AlertDescription>
          </Alert>

          <ChargingSimulator />
          <ToolGuideCta guidePath="/simulation/charging/guide" toolName="Charging Simulator" />
        </div>
      </section>
    </div>
  );
};

export default ChargingSimulatorPage;
